import React, { HtmlHTMLAttributes } from 'react';

import { Container } from './styles';

interface SeparateProps extends HtmlHTMLAttributes<HTMLDivElement> {
  label?: string;
}

const SeparateLabel: React.FC<SeparateProps> = ({
  label,
  children,
  ...rest
}) => {
  return (
    <Container {...rest}>
      {label && <span>{label}</span>} <div /> {children}
    </Container>
  );
};

export { SeparateLabel };
